<template>
<div>
  <textarea class="uk-textarea" v-model="params.desc" name="book" placeholder="Задание для работы в тетради"></textarea>
</div>
</template>

<script>
export default {
  name: "settings",
  props: ['homework_params'],
  data() {
    return {
      params: {
        desc: "",
        title: "Работа в тетрадях",
        code: "book"
      }
    }
  },
  watch: {
    params: {
      handler: function (newValue) {
        this.$emit('params_changed', this.params);
      },
      deep: true
    }
  },
  created() {
    if (this.homework_params) {
      this.params = this.homework_params
    }
  },
  mounted() {
    this.$emit('params_changed', this.params);
  }
}
</script>
